import { FC, useContext, useState, useEffect, ChangeEvent } from 'react';
import styled from 'styled-components';
import { MenteeEditContext } from '../../index'; 
import Button from 'components/Button';
import Space from 'components/Space';
import axios from 'utils/privateAxiosInstance';

// --- STYLES (Ne pas les supprimer !) ---
const TrackingContainer = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const StyledTextArea = styled.textarea`
  width: 100%;
  min-height: 300px;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #004b94; 
  }
`;

// --- COMPOSANT PRINCIPAL ---
const MenteeTracking: FC = () => {
  const { mentee } = useContext(MenteeEditContext);
  const [notes, setNotes] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  // Charger les notes au démarrage
  useEffect(() => {
    const savedNotes = (mentee as any)?.trackingNotes || "";
    setNotes(savedNotes);
  }, [mentee]);

  // Sauvegarder les notes via API
  const handleSave = async () => {
    if (!mentee?.id) return;

    setLoading(true);
    try {
    // L'URL relative /user/ sera complétée par l'instance privée
    await axios.patch(`/user/${mentee.id}`, {
            trackingNotes: notes
      });

      alert("Notes enregistrées avec succès !");
    } catch (error) {
      console.error("Erreur lors de la sauvegarde :", error);
      alert("Erreur lors de la sauvegarde.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <TrackingContainer>
      <h3>Suivi administratif : {mentee?.firstName} {mentee?.lastName}</h3>
      <p style={{ color: '#666' }}>
        Cet espace est réservé aux chargées de mentorat pour noter le suivi.
      </p>
      <Space height={2} />
      
      <StyledTextArea 
        placeholder="Saisissez vos notes de suivi ici..."
        value={notes}
        // Ajout du type ChangeEvent pour corriger l'erreur 'e'
        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNotes(e.target.value)}
        disabled={loading}
      />
      
      <Space height={2} />
      
      <Button color="primary" onClick={handleSave} disabled={loading}>
        {loading ? 'Enregistrement...' : 'Enregistrer les notes'}
      </Button>
    </TrackingContainer>
  );
};

export default MenteeTracking;